import { MatDialogRef } from '@angular/material/dialog';
import { AddressListSearchCriteria } from '../models';
import { ExportAddress } from '../constants';
import { ExportDialogComponent } from '../../../../ui-kit';

export class AddressListLoad {
  public static readonly type = '[AddressList] Load';

  constructor(public payload: AddressListSearchCriteria) {}
}

export class AddressListInitialState {
  public static readonly type = '[AddressList] Set initial state';
}

/**
 * Action for starting export excel file
 */
export class AddressListExportToFileStart {
  public static readonly type = '[AddressListExport] start';

  constructor(
    public payload: {
      name: string;
      filterView: Partial<AddressListSearchCriteria>;
      dialogRef: MatDialogRef<ExportDialogComponent>;
      navigationNeeded: boolean;
      addressExport: ExportAddress;
    },
  ) {}
}
